/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryChangeStatusRequest } from './RevisdomAPIViewModelsEntryChangeStatusRequest';
import {
    RevisdomAPIViewModelsEntryChangeStatusRequestFromJSON,
    RevisdomAPIViewModelsEntryChangeStatusRequestFromJSONTyped,
    RevisdomAPIViewModelsEntryChangeStatusRequestToJSON,
    RevisdomAPIViewModelsEntryChangeStatusRequestToJSONTyped,
} from './RevisdomAPIViewModelsEntryChangeStatusRequest';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryChangeEntriesStatusRequest
 */
export interface RevisdomAPIViewModelsEntryChangeEntriesStatusRequest {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryChangeStatusRequest>}
     * @memberof RevisdomAPIViewModelsEntryChangeEntriesStatusRequest
     */
    entries?: Array<RevisdomAPIViewModelsEntryChangeStatusRequest> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryChangeEntriesStatusRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryChangeEntriesStatusRequest(value: object): value is RevisdomAPIViewModelsEntryChangeEntriesStatusRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryChangeEntriesStatusRequestFromJSON(json: any): RevisdomAPIViewModelsEntryChangeEntriesStatusRequest {
    return RevisdomAPIViewModelsEntryChangeEntriesStatusRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryChangeEntriesStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryChangeEntriesStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(RevisdomAPIViewModelsEntryChangeStatusRequestFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryChangeEntriesStatusRequestToJSON(json: any): RevisdomAPIViewModelsEntryChangeEntriesStatusRequest {
    return RevisdomAPIViewModelsEntryChangeEntriesStatusRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryChangeEntriesStatusRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryChangeEntriesStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(RevisdomAPIViewModelsEntryChangeStatusRequestToJSON)),
    };
}

